// src/config/constants.js

export const MASTER_PIN = "1234";

// Link da planilha (pode manter o mesmo ou mudar se quiser testar outro catálogo)
export const DEFAULT_XLSX_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vRseAVjs6VEwSUFJJOSnBgXS5ssRC9oT5Yl-TZ6vSILaG7JKQnFT9YG1yBryVBDGBzbnXATtn4ot0-F/pub?output=xlsx";

export const STORAGE_KEY = "estoque_catalog_cache";

// Firebase Configuration Removed

// --- BANCO DE DADOS ATIVO ---
// Iniciando migração para banco local
// Mude para "estoque-oficial" quando for subir para produção.
// Por enquanto, usamos este nome para criar um ambiente isolado.
export const APP_COLLECTION_ID = "estoque-teste-modular-v1";
